/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, asJson } from '../lib/api.js';
import { GB, GB_EMPTY, GB_PER_DAY, PB_URL } from '../lib/config.js';
import { playBlip, playPop } from '../lib/sound.js';
import { dayKey } from '../lib/text.js';
import * as store from '../lib/store.js';

export default {
  gbQuota() {
      const today = dayKey();
      let day = '', used = 0;
      try {
        day = store.get('gp_gb_day') || '';
        used = Number(store.get('gp_gb_used') || 0) || 0;
      } catch (e) {}
      if (day !== today) { used = 0; this.gbSpend(0); }
      return used;
    },

  gbSpend(n) {
      try {
        store.set('gp_gb_day', dayKey());
        store.set('gp_gb_used', String(n));
      } catch (e) {}
    },

  async fetchGuestbook() {
      if (!PB_URL) return;
      try {
        const res = await api(`${PB_URL}/api/collections/paal_guestbook/records?sort=created&perPage=1`);
        // 404 = collectie bestaat niet, 403 = bestaat wel maar mag niet gelezen worden.
        if (!res.ok) { this.setState({ gbMissing: true, gbStatus: res.status }); return; }
        const data = await res.json();
        let rec = (data.items || [])[0];
        if (!rec) {
          const mk = await api(`${PB_URL}/api/collections/paal_guestbook/records`, asJson('POST', { pixels: GB_EMPTY, lastBy: '' }));
          if (mk.ok) rec = await mk.json();
          else { this.setState({ gbMissing: true, gbStatus: mk.status }); return; }
        }
        if (!rec) return;
        this.gbId = rec.id;
        const px = (rec.pixels || '').length === GB * GB ? rec.pixels : GB_EMPTY;
        // owners: per pixelpositie het accountId van wie er als laatste op tekende.
        let owners = {};
        try { owners = JSON.parse(rec.owners || '{}') || {}; } catch (e) {}
        this.setState({ gbPixels: px, gbOwners: owners, gbMissing: false, gbStatus: 0 });
      } catch (e) {
        this.setState({ gbMissing: true, gbStatus: 0 });
      }
    },

  gbClick(e) {
      const el = e.currentTarget;
      const r = el.getBoundingClientRect();
      // Binnen de rand: het vel staat op de achtergrond, en die begint ná de rand.
      const x = Math.floor(((e.clientX - r.left - el.clientLeft) / (el.clientWidth || r.width)) * GB);
      const y = Math.floor(((e.clientY - r.top - el.clientTop) / (el.clientHeight || r.height)) * GB);
      if (x < 0 || y < 0 || x >= GB || y >= GB) return;
      this.placeGbPixel(y * GB + x);
    },

  async placeGbPixel(i) {
      if (!this.ensureName('Log in of maak een account aan om op het gastenboek te krabbelen.')) return;
      if (this.state.gbSaving) return;
      if (!this.gbId) { this.notify('Het gastenboek staat nog niet op de server klaar.'); return; }
      const used = this.gbQuota();
      if (used >= GB_PER_DAY) {
        this.notify('Je pixels van vandaag zijn op. Morgen mag je weer ' + GB_PER_DAY + ' pixels zetten.');
        return;
      }
      const ch = this.state.gbColor < 0 ? '.' : (this.state.gbColor || 0).toString(16);
      const cells = (this.state.gbPixels || GB_EMPTY).split('');
      if (cells[i] === ch) return;
      const prev = cells[i];
      const prevOwner = (this.state.gbOwners || {})[i] || '';
      this.gbUndo = (this.gbUndo || []).concat([{ i, prev, prevOwner }]).slice(-40);
      this.gbSpend(used + 1);
      this.setState({ gbUsed: used + 1 });
      playPop();
      this.gbWrite(i, ch, ch === '.' ? '' : (this.state.accountId || ''));
    },

  // Hoverkaartje op het vel: wie zette hier als laatste een pixel?
  // De binnenkant van het vel, zonder de rand: daar staan de pixels.
  gbBinnen(el) {
      const r = el.getBoundingClientRect();
      return { left: r.left + el.clientLeft, top: r.top + el.clientTop, width: el.clientWidth || r.width, height: el.clientHeight || r.height, rand: el.clientLeft || 0 };
    },

  gbHoverEnter(e) { this.gbRect = this.gbBinnen(e.currentTarget); },

  gbHoverMove(e) {
      const r = this.gbRect || (this.gbRect = this.gbBinnen(e.currentTarget));
      const cw = r.width / GB, chh = r.height / GB;
      const x = Math.floor((e.clientX - r.left) / cw), y = Math.floor((e.clientY - r.top) / chh);
      if (x < 0 || y < 0 || x >= GB || y >= GB) { this.gbHoverOut(); return; }
      const i = y * GB + x;
      if (i === this.gbCell) return;
      this.gbCell = i;
      const owner = (this.state.gbOwners || {})[i];
      const painted = ((this.state.gbPixels || '')[i] || '.') !== '.';
      if (!owner || !painted) { this.gbTipClear(); return; }
      // Boven de bovenste rijen is geen plek voor de bubbel; die klapt dan naar onderen.
      // De bubbel hangt in de wikkel, en die begint bij de buitenkant van de rand.
      const b = r.rand || 0;
      const tip = { i, id: owner, left: b + (x + 0.5) * cw, top: b + (y < 4 ? (y + 1) * chh + 8 : y * chh - 8), below: y < 4 };
      if (this.state.gbTip) { this.setState({ gbTip: tip }); return; }
      clearTimeout(this.gbTipTimer);
      this.gbTipTimer = setTimeout(() => this.setState({ gbTip: tip }), 333);
    },

  gbHoverOut() { this.gbCell = -1; this.gbRect = null; this.gbTipClear(); },

  gbTipClear() { clearTimeout(this.gbTipTimer); if (this.state.gbTip) this.setState({ gbTip: null }); },

  undoGbPixel() {
      const stack = this.gbUndo || [];
      const last = stack[stack.length - 1];
      if (!last || this.state.gbSaving || !this.gbId) return;
      this.gbUndo = stack.slice(0, -1);
      const used = Math.max(0, this.gbQuota() - 1);
      this.gbSpend(used);
      this.setState({ gbUsed: used });
      playBlip();
      this.gbWrite(last.i, last.prev, last.prevOwner || '');
    },

  // Zet één pixel op het gedeelde vel: eerst de verse serverversie, dan mijn pixel erop.
  async gbWrite(i, ch, owner) {
      const cells = (this.state.gbPixels || GB_EMPTY).split('');
      cells[i] = ch;
      const mine = cells.join('');
      const myOwners = Object.assign({}, this.state.gbOwners || {});
      if (owner) myOwners[i] = owner; else delete myOwners[i];
      this.setState({ gbPixels: mine, gbOwners: myOwners, gbSaving: true });
      try {
        let next = mine, nextOwners = myOwners;
        const one = await api(`${PB_URL}/api/collections/paal_guestbook/records/${this.gbId}`);
        if (one.ok) {
          const j = await one.json();
          const server = (j.pixels || '').split('');
          if (server.length === GB * GB) { server[i] = ch; next = server.join(''); }
          let so = {};
          try { so = JSON.parse(j.owners || '{}') || {}; } catch (e) {}
          if (owner) so[i] = owner; else delete so[i];
          nextOwners = so;
        }
        const url = `${PB_URL}/api/collections/paal_guestbook/records/${this.gbId}`;
        const body = { pixels: next, lastBy: this.state.author || '' };
        if (!this.gbNoOwners) body.owners = JSON.stringify(nextOwners);
        let res = await api(url, asJson('PATCH', body));
        // Server zonder het veld "owners"? Dan gaan de pixels voor en bewaren we de namen niet.
        if (!res.ok && body.owners) {
          this.gbNoOwners = true;
          delete body.owners;
          res = await api(url, asJson('PATCH', body));
        }
        if (!res.ok) throw new Error(res.status);
        this.setState({ gbPixels: next, gbOwners: nextOwners, gbSaving: false });
      } catch (e) {
        this.setState({ gbSaving: false });
        this.notify('Je pixel kon niet opgeslagen worden. Staat de server aan?');
      }
    }
};
